angular.module('impactx.list').directive('ixPersistentListFilters', function () {
    return {
        restrict: 'E',
        controller: 'PersistentListFiltersCtrl',
        controllerAs: 'persistentListFiltersCtrl',
        templateUrl: 'shared/list/templates/persistent-list-filters.tmpl.html',
        scope: {
            collapsed: "=",
            listConfig: "=",
            refreshListFn: "&"
        }
    }
});